import React from 'react';
import { useTranslation } from 'react-i18next';
import './AuthError.css';

interface AuthErrorProps {
  message?: string;
  onRetry?: () => void;
}

const AuthError: React.FC<AuthErrorProps> = ({ message, onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="auth-error-container" role="alert">
      <div className="auth-error-content">
        <h1 className="auth-error-title">{t('auth.error.title')}</h1>
        <p className="auth-error-message">
          {message || t('auth.error.message')}
        </p>
        {onRetry && (
          <button 
            className="button button-primary auth-error-retry"
            onClick={onRetry}
          >
            {t('auth.error.retry')}
          </button>
        )}
        <p className="auth-error-help">
          {t('auth.error.help')}
        </p>
      </div>
    </div>
  );
};

export default AuthError;

